export enum SortTypeEnum {
    none,
    asc,
    desc,
}
